import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { BehavioralService } from "../claimprocess/service/behavioral.service";
import { SetUpPasswordService } from "../claimprocess/service/setUpPassword.service";
import { ISetUpPasswordResetRequest, ResetPasswordResponse } from "../claimprocess/model/setUpPassword.model";
import { IQuestionAnswer } from "../claimprocess/model/question.answer.model";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  templateUrl: "./template/resetPassword.component.html",
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
          .error-message {
            display: flex;
            width: 1208px;
            padding-right: 0px;
            flex-direction: row;
            align-items: flex-start;
            gap: 10px;
            border-radius: 5px;
            border: 1px solid var(--ngp-error-light-500, #bd2b41);
            background: var(--ngp-primary-0, #fff);

            .error-message-left {
              display: flex;

              width: 5%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
              border-radius: 5px 0px 0px 5px;
              background: var(--ngp-error-light-500, #bd2b41);
            }

            .error-message-middle {
              display: flex;
              width: 90%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
            }

            .error-message-right {
              display: flex;
              width: 5%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
            }
          }







    `,
  ],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  resetPasswordForm: UntypedFormGroup;
  submitted = false;
  username: string;
  $subs: Subscription;

  confirmPasswordShow = false;
  passwordShow = false;
  securityQuestionsAnswered: IQuestionAnswer[];

  errorResponse;
  displayError = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private behavioralService: BehavioralService,
    private setUpPassword: SetUpPasswordService
  ) {}

  ngOnDestroy(): void {
  }
  ngOnInit() {

    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(12)]],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: [General(), MustMatch("password", "confirmPassword")],
      }
    );

this.behavioralService.questionAnswer$.subscribe((a) => {this.securityQuestionsAnswered = a})

  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    }




    this.behavioralService.receiveQAResetPasswordList().subscribe(a=> {


      let data: ISetUpPasswordResetRequest = {
        user_name: a.user_name,
        user_type: a.user_type,
        new_password: this.resetPasswordForm.get('password').getRawValue(),
        security_questions: a.security_questions
      };

      const isHTTPResponseError = (err: unknown): err is HttpErrorResponse => err instanceof HttpErrorResponse;

      this.setUpPassword.postResetPasswordData(data).subscribe((resp: ResetPasswordResponse) =>
      
      {
        if (isHTTPResponseError(resp)) {
          // console.error("Failed to reset password! " + resp.error.exception)
          this.errorResponse = resp.error.exception;
          this.displayError = true;
          this.submitted = false;
        } else {
          this.router.navigate(["identityiq/external/forgotPassword/success"])
        }
      },
      (err) => {console.log(err)})

    })

    //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    
  }

  closeDisplayError() {
    this.displayError = false;
  }

  toggle(str: string) {
    if (str === "passwordShow") {
      const password = document.querySelector("#password");
      const type =
        password.getAttribute("type") === "password" ? "text" : "password";
      password.setAttribute("type", type);
      this.passwordShow = !this.passwordShow;
    }

    if (str === "confirmPasswordShow") {
      const password = document.querySelector("#confirmPassword");
      const type =
        password.getAttribute("type") === "password"
          ? "text"
          : "password";
      password.setAttribute("type", type);

      this.confirmPasswordShow = !this.confirmPasswordShow;
    }
  }
}
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export function General() {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls["password"];

    if (control.errors && !control.errors.general) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (
      control.value.match(/[A-Z]/) && // at least 1 upper case letter
      control.value.match(/[a-z]/) && // at least 1 lower case letter
      control.value.match(/[0-9]/) // at least 1 digit
      //&& !input.match(/\s/)   // no whitespace
    ) {
      control.setErrors(null);
    } else {
      control.setErrors({ general: true });
    }
  };
}
